<div class="modal-backdrop">
  <div id="sideInsightContent" class="modal-content2">
    <h2>SDK Risk Insight</h2>
    <button class='btn btn-link side-nav-mobile-close' (click)='navCloseClick.emit( $event )'>
      <img src="/assets/icons/icon-close.svg" alt="Close Icon" />
    </button>

    <div id="overview" class="container-fluid main-content flex-gap" *ngIf="data">
      <div class="title-cont">
        <div class="d-flex d-lg-flex gap-2">
          <img class="sdk-developer-details-logo" width="48" height="48"
            src="https://cdn.pixalate.com/sdk/icons/{{data?.overview?.sdkWebsite | extractDomain}}.png"
            alt="SDK Developer Logo" onerror="this.src='/assets/icons/icon-72x72-grey.png'" />
          <div class="d-flex flex-column flex-lg-row flex-nowrap gap-1">
            <span class="sdk-developer-name">{{ selectedSdk?.sdkName }}</span>
            <div class="d-flex flex-nowrap gap-2">
              <span class="sdk-badge app-store">{{ data?.overview?.appStore | capitalizeAppStore }}</span>
              <span class="sdk-badge type">{{ data?.overview?.type }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="body-content" id="body-content" *ngIf="data && !loadingData && !showNoDataFound">
        <div class="container-fluid d-flex flex-column flex-gap p-0">
          <app-sdk-overview-risks-v2></app-sdk-overview-risks-v2>
          <app-sdk-privacy-disclosure></app-sdk-privacy-disclosure>
          <app-sdk-identity></app-sdk-identity>
        </div>
      </div>
      <ng-template [ngTemplateOutlet]="loadingDataTemplate"></ng-template>
      <ng-template [ngTemplateOutlet]="noDataFoundTemplate"></ng-template>
    </div>
  </div>
</div>

<ng-template #loadingDataTemplate>
  <div class="loading-data-container p-4" *ngIf="loadingData">
    Loading data
    <i class="fa fa-spin fa-spinner ml-2"></i>
  </div>
</ng-template>

<ng-template #noDataFoundTemplate>
  <div class="no-data-container" *ngIf="!loadingData && showNoDataFound">
    <div class="alert alert-warning" role="alert">
      Sorry, no further information was found for {{selectedSdk?.sdkName}}.
    </div>
  </div>
</ng-template>